import EmailIcon from "@mui/icons-material/Email";
import TextsmsIcon from "@mui/icons-material/Textsms";
import Stack from "@mui/material/Stack";
import Tooltip from "@mui/material/Tooltip";
import AppSettingsAltIcon from '@mui/icons-material/AppSettingsAlt';

interface MediumSummaryIndicatorsProps {
    email: boolean;
    sms: boolean;
    app: boolean;
}

const MediumSummaryIndicators = (props: MediumSummaryIndicatorsProps) => {
    return (
        <Stack
            direction="row"
            spacing={3}
        >
            <Tooltip title={props.email ? "Email enabled!" : "Email not configured"}>
                <EmailIcon color={props.email ? "success" : "disabled"} />
            </Tooltip>
            &nbsp;
            <Tooltip title={props.sms ? "SMS enabled!" : "SMS not configured"}>
                <TextsmsIcon color={props.sms ? "success" : "disabled"} />
            </Tooltip>
            &nbsp;
            <Tooltip title={props.app ? "App enabled!" : "App not configured"}>
                <AppSettingsAltIcon color={props.app ? "success" : "disabled"} />
            </Tooltip>
        </Stack>
    )
}


export default MediumSummaryIndicators